'use client'

import { usePathname } from 'next/navigation'
import { createContext, useContext, ReactNode } from 'react'
import { domainRewriteMap } from '@/lib/config/domainRoutes'

interface FooterContextType {
  hideFooter: boolean
}

const FooterContext = createContext<FooterContextType>({
  hideFooter: false,
})

interface HeaderFooterProviderProps {
  children: ReactNode
}

const FooterProvider = ({ children }: HeaderFooterProviderProps) => {
  const pathname = usePathname()

  const hidefotterList = [
    '/login',
    '/technology',
    '/login/reset-password',
    '/term-of-service',
    '/privacy-policy',
    '/apply',
    '/join',
    '/ktechpioneers',
  ]

  // 도메인 전용 페이지에서는 항상 Footer 숨김
  const isDomainExclusive =
    typeof window !== 'undefined' &&
    window.location.hostname in domainRewriteMap

  // 미들웨어와 동일한 로직
  const isHideFooter =
    isDomainExclusive || hidefotterList.some(path => pathname.includes(path))

  const hideFooter = isHideFooter

  return <FooterContext.Provider value={{ hideFooter }}>{children}</FooterContext.Provider>
}

export const useHeaderFooter = () => {
  const context = useContext(FooterContext)
  if (!context) {
    throw new Error('useHeaderFooter must be used within HeaderFooterProvider')
  }
  return context
}

export default FooterProvider
